import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { MaterialModule } from '../material.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OrdersListComponent } from './orders-list/orders-list.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { OrderFormComponent } from './order-form/order-form.component';
import { OrderFormChangeTarifComponent } from './order-form-change-tarif/order-form-change-tarif.component';
import { OrderFormRecountConfirmComponent } from './order-form-recount-confirm/order-form-recount-confirm.component';
import { OrderFormDeleteComponent } from './order-form-delete/order-form-delete.component';
import { OrderFormDriverDriverUnassignComponent } from './order-form-driver-driver-unassign/order-form-driver-driver-unassign.component';
import { OrderFormOptionsComponent } from './order-form-options/order-form-options.component';
import { OrdersListTimerComponent } from './orders-list-timer/orders-list-timer.component';
import { OrderIncressTimeComponent } from './order-incress-time/order-incress-time.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
import { Client } from '../shared/services/client';
import { FeatureIconPipe } from './pipe/feature-icon.pipe';
import { OrdersSearchPipe } from './pipe/orders-search.pipe';
import { NotificationsPipe } from './pipe/notifications.pipe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedModule } from '../shared/shared.module';
import { DashboardDriversComponent } from './dashboard-drivers/dashboard-drivers.component';
import { AddressService } from './services/address.service';
import { PassangerService } from './services/passanger.service';
import { SipWsService } from './services/sip-ws.service';
import { DialogStatusService } from '@app/dashboard/services/dialog-status.service';
import { DriverNoticeModule } from '@app/driver-notice/driver-notice.module';
import { NotificationsComponent } from './notifications/notifications.component';
import { MapService } from '@app/shared/services/map.service';
import { CardPaymentComponent } from './card-payment/card-payment.component';
import { CardPayComponent } from './card-pay/card-pay.component';
import { LockService } from './services/lock.service';
import { PaymentService } from './services/payment.service';
import { KsInfoModalComponent } from './ks-info-modal/ks-info-modal.component';
import { TaxiServiceInfoService } from './services/taxi-service-info.service';
import { SortProductsPipe } from './pipe/sort-products.pipe';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    // DashboardRoutingModule,
    TranslateModule,
    SharedModule,
    InfiniteScrollModule,
    DriverNoticeModule
  ],
  declarations: [
    DashboardComponent,
    OrdersListComponent,
    OrderDetailComponent,
    OrderFormComponent,
    OrderFormChangeTarifComponent,
    OrderFormRecountConfirmComponent,
    OrderFormDeleteComponent,
    OrderFormDriverDriverUnassignComponent,
    OrderFormOptionsComponent,
    OrdersListTimerComponent,
    OrderIncressTimeComponent,
    FeatureIconPipe,
    OrdersSearchPipe,
    NotificationsPipe,
    DashboardDriversComponent,
    NotificationsComponent,
    CardPaymentComponent,
    CardPayComponent,
    KsInfoModalComponent,
    SortProductsPipe,
  ],
  entryComponents: [
    OrderFormComponent,
    OrderIncressTimeComponent,
    OrderFormRecountConfirmComponent,
    OrderFormDeleteComponent,
    OrderFormDriverDriverUnassignComponent,
    OrderFormChangeTarifComponent,
    DashboardDriversComponent,
    CardPaymentComponent,
    KsInfoModalComponent
  ],
  providers: [
    TranslateService,
    AddressService,
    PassangerService,
    SipWsService,
    MapService,
    LockService,
    PaymentService,
    DialogStatusService,
    TaxiServiceInfoService
  ],
  exports: []
})
export class DashboardModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer, client: Client) {
    const icons = [
      'edit',
      'callClient',
      'serverCall',
      'deliveredSms',
      'serverSms',
      'smsError',
      'smsCancel',
      'smsPending',
      'smsProcessing',
      'smsSent',
      'callClient1',
      'callClient2',
      'callDriver',
      'upAddr',
      'downAddr',
      'addAddr',
      'delAddr',
      'editPrice',
      'preOrder',
      'curOrder',
      'o-air',
      'o-delivery',
      'o-pet',
      'o-trunk',
      'ether',
      'bonus',
      'recently',
      'rotate'
    ];
    icons.map(icon => {
      iconRegistry.addSvgIcon(icon, sanitizer.bypassSecurityTrustResourceUrl(`${client.getImgsUrl()}${icon}.svg`));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard.module.ts